export default __webpack_public_path__ + "static/media/ogm.91fb1bf1.png";